import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <React.Fragment>
    <BrowserRouter basename={'/app'}>
      <App />
    </BrowserRouter>
  </React.Fragment>,
  document.getElementById('root')
);


